import { Component, OnInit, Input } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { JockeysService } from '../../../services/jockeys.service';

import { CommentComponent } from '../../modals/comment/comment.component';
import { EventsService } from '../../../services/events.service';

@Component({
  selector: 'app-jockey-comments',
  templateUrl: './jockey-comments.component.html',
  styleUrls: ['./jockey-comments.component.scss']
})
export class JockeyCommentsComponent implements OnInit {

  @Input() jockey;
  meta: {
    loading: boolean,
    saving: boolean,
    results: {
      currentPage: number,
      pageSize: number,
      lastPage: number,
      totalResult: number
    }
  };

  constructor(
    private modalService: NgbModal,
    private notification: ToastrService,
    private jockeysService: JockeysService,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.meta = {
      loading: false,
      saving: false,
      results: {
        currentPage: null,
        pageSize: null,
        lastPage: null,
        totalResult: null
      }
    };

    this.loadResults(this.jockey.jockeyId);
  }

  loadResults = (jockeyId, page = 1) => {
    console.log(jockeyId, page);
    this.meta.loading = true;
    this.jockey.comments = [];
    this.jockeysService.getJockeyComments({jockeyId: jockeyId}, page).subscribe(
      res => {
        this.jockey.comments = res.data;
        this.meta.results = {
          currentPage: res.current_page,
          pageSize: res.per_page,
          lastPage: res.last_page,
          totalResult: res.total
        };
        this.meta.loading = false;
      },
      err => {
        this.notification.error(`Could't get the Jockey Comments: ${this.eventsService.getApiErrorMessage(err)}`, 'Error!');
        this.meta.loading = false;
      }
    );
  }

  openComment = (id) => {
    const modalWindow = this.modalService.open(CommentComponent, { centered: true, backdrop: 'static', size: 'lg'});
    modalWindow.componentInstance.comment = {id};
    modalWindow.result.then((result) => {
      console.log(`[ DEBUG ] Modal Closed with payload`, result);
    }, (reason) => {
      console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      if (reason === 'comment deleted') {
        this.loadResults(this.jockey.jockeyId, this.meta.results.currentPage);
      }
    });
  }

}
